import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const defaultView: ThemeUICSSObject = {
  variant: 'layout.execution.components.uploader.defaultView',

  'ul.uploaderFilesList': {
    p: 0,
    display: 'block',
  },
  /* PREPEND HERE */
};

export default defaultView;
